/**
 * Preseed Filter Configuration
 *
 * Filter configurations specific to preseed (status filter only)
 *
 * Pattern matches:
 * - src/sections/seeds/config/filters.tsx
 */

import { SeedStatus } from '@/types';
import type { DropdownOption } from '@/types/dropdown.types';

// ============================================================================
// FILTER OPTIONS
// ============================================================================

/**
 * Status filter options for preseed
 *
 * Preseed only has status filter (no registrar, email, country, etc.)
 */
export const PRESEED_STATUS_FILTERS: DropdownOption[] = [
  {
    label: 'Approved',
    value: SeedStatus.Accept,
    id: SeedStatus.Accept,
  },
  {
    label: 'Pending',
    value: SeedStatus.Pending,
    id: SeedStatus.Pending,
  },
  {
    label: 'Rejected',
    value: SeedStatus.Reject,
    id: SeedStatus.Reject,
  },
];

/**
 * Get available filter fields for preseed
 *
 * Preseed only supports status filtering
 *
 * @returns Array of visible filter field names for preseed
 */
export const getPreseedFilterFields = (): string[] => {
  return ['status'];
};
